import React from 'react';
import { motion } from 'framer-motion';

export default function Instructor() {
  const stats = [
    { label: 'ประสบการณ์', value: '19 ปี' },
    { label: 'วิเคราะห์จริง', value: '3,000+' },
    { label: 'นักลงทุน/นักธุรกิจ', value: '80%' },
  ];

  return (
    <section className="section-padding bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* User Provided Image 2 - Instructor */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[3/4] overflow-hidden bg-zinc-100 relative z-10 shadow-2xl">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/471e332637c745cac6e5f952a1669a461aea7ff8853c3b4ee7dd2b5f799ce1f00d91c0ccf6cd346bf4393cbd10a6b0de/images/aW1hZ2UvanBlZw==/92ed84ecc93d964050fc2b8e933bb95f.jpg" 
                alt="อ.รวิ อัญญากาญจน์" 
                className="w-full h-full object-cover"
              />
            </div>
            {/* CI Element - Solid Red Block */}
            <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 bg-brand-red z-0"></div>
          </motion.div>

          <div>
            <span className="text-brand-red font-bold uppercase tracking-widest text-sm mb-4 block">ผู้สอน</span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-zinc-900 mb-10 leading-tight">
              ทำไมต้องเรียนกับ <br /> อ.รวิ อัญญากาญจน์
            </h2>
            
            <div className="grid grid-cols-3 gap-6 mb-12 py-8 border-y border-zinc-200">
              {stats.map((stat, i) => (
                <div key={i}>
                  <div className="text-3xl md:text-5xl font-black text-brand-red mb-2">{stat.value}</div>
                  <div className="text-zinc-500 font-bold uppercase text-[10px] sm:text-xs tracking-wider">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="space-y-6 text-zinc-600 text-lg leading-relaxed font-medium">
              <p>
                ในบรรดาดวงที่ อ.รวิ ได้ดูให้ มีทั้งคนทำงานทั่วไป นักลงทุนรายย่อย เจ้าของธุรกิจ SME ไปจนถึงนักธุรกิจระดับหมื่นล้าน 
                ที่ประสบความสำเร็จทางการเงินและการลงทุนในรูปแบบที่แตกต่างกันไป ทำให้มีทั้งข้อมูลเชิงลึกและประสบการณ์ตรงที่หาไม่ได้จากการอ่านตำราเพียงอย่างเดียว
              </p>
              <p>
                ในหลักสูตรนี้ อ.รวิ จะสอนให้เห็นภาพเปรียบเทียบ ระหว่างปาจื้อแนวดั้งเดิม และแนวทางประยุกต์สำหรับยุคการลงทุนสมัยใหม่ 
                เพื่อให้คุณนำไปใช้ได้จริงกับชีวิตและพอร์ตของคุณเอง ไม่ใช่แค่ท่องจำทฤษฎี
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}